var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.locale}},[_vm._l((_vm.data),function(item,index){return (_vm.isLogin)?_c('keep-alive',{key:index},[(_vm.$route.meta.name == item)?_c('router-view'):_vm._e()],1):_vm._e()}),(!_vm.$route.meta.keepAlive || !_vm.isLogin)?_c('router-view'):_vm._e()],2),_c('GloboalTips')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }